import { articleListedState as state } from './articleListedState';
import { chapters, countersActiveChapter, dataChapterBoxWrappers } from './articleListedElements';

const CLASS_ARTICLE_LISTED_CHAPTER = 'article-listed-chapter';

export const articleListedToggleChapter = () => {
  chapters.forEach((chapter: HTMLDivElement) => {
    const CLASS_ACTIVE = `${CLASS_ARTICLE_LISTED_CHAPTER}--active`;
    const chapterNumber = Number(chapter.getAttribute(`data-${CLASS_ARTICLE_LISTED_CHAPTER}`));

    if (chapterNumber === state.getActiveChapter()) {
      chapter.classList.add(CLASS_ACTIVE);
    } else if (chapter.classList.contains(CLASS_ACTIVE)) {
      chapter.classList.remove(CLASS_ACTIVE);
    }
  });
};

export const activeChapterToInfoBox = () => {
  if (countersActiveChapter)
    countersActiveChapter.forEach((element) => {
      (element as HTMLElement).innerText = state.getActiveChapter().toString();
    });

  if (dataChapterBoxWrappers)
    dataChapterBoxWrappers.forEach((element) => {
      element.classList.remove('hidden');
    });
};
